import { CaseDeserialized } from "src/cases/queries/casesTypes";

export type CaseSourceDecision = {
  decisionId: string;
  flowId: string;
  flowVersionId: string;
};

// The decision that created the case; undefined for API/manual creation.
export const getCaseSourceDecision = (
  caseData?: CaseDeserialized,
): CaseSourceDecision | undefined => {
  const decision = caseData?.data.related_decisions?.find(
    (related) => related.kind === "case_creation",
  );

  if (!decision?.flow_id || !decision?.flow_version_id) {
    return undefined;
  }

  return {
    decisionId: decision.id,
    flowId: decision.flow_id,
    flowVersionId: decision.flow_version_id,
  };
};
